import React from "react";
import styles from "./ControlBtns.module.css";
import PlayBtn from "./PlayBtn/PlayBtn";
import ChartTypeRadio from "./ChartTypeRadio/ChartTypeRadio";
import refresh from "../../../assets/images/common/icons/refresh.svg";
import move from "../../../assets/images/common/icons/move.svg";
import plus from "../../../assets/images/common/icons/plus.svg";
import minus from "../../../assets/images/common/icons/minus.svg";
import slow from "../../../assets/images/common/icons/slow.svg";
import fast from "../../../assets/images/common/icons/fast.svg";

const ControlButtons = ({ options, className, ...props }) => {
  const o = {
    showReplay: options.showReplay !== undefined ? options.showReplay : true,
    replyF: options.replyOnClick,

    showPlay: options.showPlay !== undefined ? options.showPlay : true,
    plyF: options.plyOnClick,
    playDef: options.playDef,
    playRef: options.playRef,

    showMove: options.showMove !== undefined ? options.showMove : true,
    moveFunc: options.moveOnClick,
    moveBRef: options.moveBRef,
    moveFRef: options.moveFRef,

    showZoom: options.showZoom !== undefined ? options.showZoom : false,
    zoomF: options.zoomOnClick,
    zoomInRef: options.zoomInRef,
    zoomOutRef: options.zoomOutRef,

    showSpeed: options.showSpeed !== undefined ? options.showSpeed : true,
    speedF: options.speedOnClick,
    speedUpRef: options.speedUpRef,
    speedDownRef: options.speedDownRef,

    showType: options.showType !== undefined ? options.showType : false,
    typeF: options.typeOnClick,
    typeDef: options.typeDef,
    typeLT: options.typeLT,
    typeRT: options.typeRT,
    typeLIMG: options.typeLIMG,
    typeRIMG: options.typeRIMG,
  };

  return (
    <div className={styles.btns + (className ? " " + className : "")}>
      {o.showReplay && (
        <button className={styles.replayBtn} onClick={(e) => o.replyF(e)}>
          <img className={styles.btnImg} src={refresh} alt={"Refresh"} />
        </button>
      )}
      {o.showMove && (
        <button ref={o.moveBRef} className={styles.move + " " + styles.moveBack} onClick={() => o.moveFunc(false)}>
          <img className={styles.btnImg} src={move} alt={"Move b"} />
        </button>
      )}
      {o.showPlay && (
        <button className={styles.playBtn}>
          <PlayBtn btnRef={o.playRef} defaultChecked={o.playDef} onChange={o.plyF} />
        </button>
      )}
      {o.showMove && (
        <button ref={o.moveFRef} className={styles.move + " " + styles.moveForward} onClick={() => o.moveFunc(true)}>
          <img className={styles.btnImg} src={move} alt={"Move f"} />
        </button>
      )}
      {o.showZoom && (
        <>
          <button ref={o.zoomInRef} className={styles.zoomInBtn} onClick={(e) => o.zoomF(true)}>
            <img className={styles.btnImg} src={plus} alt={"Zoom in"} />
          </button>
          <button ref={o.zoomOutRef} className={styles.zoomOutBtn} onClick={(e) => o.zoomF(false)}>
            <img className={styles.btnImg} src={minus} alt={"Zoom out"} />
          </button>
        </>
      )}
      {o.showSpeed && (
        <>
          <button ref={o.speedDownRef} className={styles.speedDownBtn} onClick={() => o.speedF(false)}>
            <img className={styles.btnImg} src={slow} alt={"Speed up"} />
          </button>
          <button ref={o.speedUpRef} className={styles.speedUpBtn} onClick={() => o.speedF(true)}>
            <img className={styles.btnImg} src={fast} alt={"Speed down"} />
          </button>
        </>
      )}
      {o.showType && (
        <button className={styles.chartTypeRadio}>
          <ChartTypeRadio
            defaultChecked={o.typeDef}
            onChange={o.typeF}
            leftText={o.typeLT}
            rightText={o.typeRT}
            lImg={o.typeLIMG}
            rImg={o.typeRIMG}
          />
        </button>
      )}
    </div>
  );
};

export default ControlButtons;
